export function prepareSimpleCallPropsByRealtyUserId(realtyUserId, builders, sellers) {
  var builder = builders.find(function (builder) {
    return builder.realtyUserId === realtyUserId;
  });
  if (builder) {
    return {
      builders: [builder],
      sellers: [],
      singlePhoneButtonText: 'Контакты застройщика',
      withoutModal: true
    };
  }
  var seller = sellers.find(function (seller) {
    return seller.realtyUserId === realtyUserId;
  });
  if (seller) {
    return {
      builders: [],
      sellers: [seller],
      singlePhoneButtonText: 'Контакты представителя',
      withoutModal: true
    };
  }
  return {
    builders: [],
    sellers: []
  };
}